import { AppImages, assignTextStyle, LARGE_BREAKPOINT, MID_BREAKPOINT, MOBILE_BREAKPOINT, variantProvider } from '@/app'
import { AchievementsCard, Image, Page, Text, View } from '@/components'
import { useI18N } from '@codeleap/common'
import { graphql } from 'gatsby'

export default () => {
  const { t } = useI18N()

  const achievements = [
    { number: 500, text: t('about.card.users') },
    { number: 500, text: t('about.card.provider') },
    { number: 1000, text: t('about.card.jobsDone') },
  ]

  return (
    <Page pageTitle='About' styles={{ innerWrapper: styles.pageInnerWrapper }}>
      <View css={styles.innerWrapper}>
        <Image source={AppImages.About1} css={[styles.image, styles.image1]} />
        <View css={[styles.content, styles.content1]}>
          <Text css={styles.title}>
            <Text css={[styles.title, styles['title:primary2']]} text={t('about.title1')} />
            {'\u00A0' + t('about.title2')}
          </Text>
          <Text css={styles.text} text={t('about.description1')} />
          <Text css={styles.text} text={t('about.description2')} />
        </View>
        <View css={[styles.content, styles.content2]}>
          <Text css={styles.text} text={t('about.description3')} />
          <Text css={styles.text} text={t('about.description4')} />
        </View>
        <Image source={AppImages.About2} css={[styles.image, styles.image2]} />
      </View>
      <AchievementsCard achievements={achievements} style={styles.achievements} title={t('about.card.title')} />
    </Page>
  )
}

const styles = variantProvider.createComponentStyle(
  theme => ({
    pageInnerWrapper: {
      ...theme.presets.column,
    },

    innerWrapper: {
      display: 'grid',
      gridTemplateAreas: `
      "image1 content1"
      "content2 image2"
    `,
      ...theme.spacing.gap('40px 80px'),
      ...theme.spacing.paddingTop(15),
      ...theme.spacing.paddingBottom(10),

      [theme.media.down(LARGE_BREAKPOINT)]: {
        ...theme.spacing.gap('40px 64px'),
        ...theme.spacing.paddingVertical(8),
      },

      [theme.media.down(MID_BREAKPOINT)]: {
        ...theme.spacing.gap(5),
        ...theme.spacing.paddingVertical(5),
      },

      [theme.media.down(MOBILE_BREAKPOINT)]: {
        ...theme.spacing.paddingVertical(5),
        ...theme.spacing.gap(3),
        gridTemplateAreas: `
        "content1"
        "image1"
        "content2"
        "image2"
      `,
      },
    },

    image1: {
      gridArea: 'image1',
    },

    content1: {
      gridArea: 'content1',
    },

    image2: {
      gridArea: 'image2',
    },

    content2: {
      gridArea: 'content2',
    },

    content: {
      ...theme.spacing.margin('auto'),
      ...theme.presets.column,
      ...theme.spacing.gap(3),
    },

    image: {
      maxWidth: theme.spacing.value(75),
      ...theme.presets.fullWidth,
      ...theme.spacing.margin('auto'),
    },

    title: {
      ...assignTextStyle('hx')(theme).text,
      display: 'inline-block',

      [theme.media.down(LARGE_BREAKPOINT)]: {
        ...assignTextStyle('h0')(theme).text,
      },

      [theme.media.down(MID_BREAKPOINT)]: {
        ...assignTextStyle('h1')(theme).text,

      },
    },

    'title:primary2': {
      color: theme.colors.primary2,

      [theme.media.down(LARGE_BREAKPOINT)]: {
        color: theme.colors.primary2,
      },

      [theme.media.down(MID_BREAKPOINT)]: {
        color: theme.colors.primary2,
      },
    },

    text: {
      ...assignTextStyle('p1')(theme).text,
      whiteSpace: 'pre-wrap',

      [theme.media.down(MID_BREAKPOINT)]: {
        ...assignTextStyle('p3')(theme).text,
      },
    },

    achievements: {
      ...theme.spacing.marginBottom(15),

      [theme.media.down(LARGE_BREAKPOINT)]: {
        ...theme.spacing.marginBottom(8),
      },

      [theme.media.down(MOBILE_BREAKPOINT)]: {
        ...theme.spacing.marginBottom(5),
      },
    },
  }),
  true,
)

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
